import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useRestaurantBySlug } from '../lib/hooks';
import { supabase } from '../lib/supabase';
import { Table } from '../lib/types';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { Button } from '../components/ui/Button';
import { Utensils, QrCode } from 'lucide-react';
export function TablePage() {
  const {
    slug,
    tableNumber
  } = useParams<{
    slug: string;
    tableNumber: string;
  }>();
  const navigate = useNavigate();
  const {
    restaurant,
    loading: restLoading
  } = useRestaurantBySlug(slug);
  const [table, setTable] = useState<Table | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!restaurant || !tableNumber) return;
    async function fetchTable() {
      try {
        setLoading(true);
        const {
          data,
          error
        } = await supabase.from('tables').select('*').eq('restaurant_id', restaurant!.id).eq('table_number', tableNumber!).single();
        if (!error && data) {
          setTable(data);
          localStorage.setItem('noiza_current_table', data.id);
        }
      } catch (err) {
        console.error('Error fetching table:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchTable();
  }, [restaurant, tableNumber]);
  if (restLoading || loading) {
    return <div className="min-h-screen bg-brand-offwhite flex items-center justify-center p-4" data-id="element-1523">
        <Skeleton className="w-full max-w-md h-64 rounded-2xl" data-id="element-1524" />
      </div>;
  }
  if (!restaurant || !table) {
    return <div className="min-h-screen bg-brand-offwhite flex items-center justify-center p-4" data-id="element-1525">
        <EmptyState icon={QrCode} title="Mesa no encontrada" description="Este código QR no parece ser válido o la mesa no existe." actionLabel="Ir al inicio" onAction={() => navigate('/')} data-id="element-1526" />
      </div>;
  }
  const primaryColor = restaurant.primary_color || '#F59E0B';
  return <div className="min-h-screen bg-brand-offwhite flex flex-col items-center justify-center p-4" data-id="element-1527">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl overflow-hidden text-center" data-id="element-1528">
        <div className="h-32 w-full flex items-center justify-center" style={{
        backgroundColor: primaryColor
      }} data-id="element-1529">
          {restaurant.logo_url ? <img src={restaurant.logo_url} alt={restaurant.name} className="w-20 h-20 rounded-2xl shadow-lg object-cover bg-white" data-id="element-1530" /> : <div className="w-20 h-20 rounded-2xl bg-white shadow-lg flex items-center justify-center text-3xl font-bold" style={{
          color: primaryColor
        }} data-id="element-1531">
              {restaurant.name.charAt(0)}
            </div>}
        </div>

        <div className="p-8" data-id="element-1532">
          <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1533">
            Bienvenido a {restaurant.name}
          </h1>
          <div className="inline-flex items-center justify-center gap-2 bg-gray-100 px-4 py-2 rounded-full mb-6" data-id="element-1534">
            <Utensils className="w-4 h-4 text-gray-500" data-id="element-1535" />
            <span className="font-semibold text-gray-700" data-id="element-1536">
              Mesa {table.table_name || table.table_number}
            </span>
          </div>

          <p className="text-gray-600 mb-8" data-id="element-1537">
            Estás listo para ordenar desde tu mesa. Explora nuestro menú y tu
            pedido llegará directamente aquí.
          </p>

          <Button size="lg" fullWidth onClick={() => navigate(`/r/${restaurant.slug}/menu`)} style={{
          backgroundColor: primaryColor
        }} className="text-white shadow-lg" data-id="element-1538">
            Ver Menú y Ordenar
          </Button>
        </div>
      </div>
    </div>;
}